import styled from 'styled-components';
export const SubjectEditLink = styled.div`
  background-color: transparent;
  color: #4d7cfe;
  cursor: pointer;
  margin-left: 25px;
  margin-top: 5px;
  outline: none;
  text-decoration: none;
  transition: color 0.3s;

  :hover {
    text-decoration: none;
    outline: 0;
    color: #759fff;
  }
`;
export const SubjectItem = styled.div`
  margin-left: 25px;
  > span {
    word-break: break-word;
    white-space: pre-wrap;
  }
`;
export const SubjectTitle = styled.h2`
  font-size: 1em;
  font-weight: normal;
`;
export const SubjectContainer = styled.div`
  margin-top: 1em;
  margin-bottom: 1em;
`;